import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { setDynamicFavicon } from "./utils/dynamicAssets";
import { getCurrentCompanyConfig } from "./config/companies";
import { getBaseUrl } from "./utils/basePath";

const initApp = async () => {
  const baseConfig = getCurrentCompanyConfig();
  try {
    const response = await fetch(baseConfig.configPath);
    if (response.ok) {
      const jsonConfig = await response.json();
      const base = getBaseUrl();
      if (jsonConfig.logo && jsonConfig.logo.startsWith("/") && !jsonConfig.logo.startsWith(base)) {
        jsonConfig.logo = `${base}${jsonConfig.logo.slice(1)}`;
      }
      if (jsonConfig.favicon && jsonConfig.favicon.startsWith("/") && !jsonConfig.favicon.startsWith(base)) {
        jsonConfig.favicon = `${base}${jsonConfig.favicon.slice(1)}`;
      }
      (window as any).__app_config__ = { ...baseConfig, ...jsonConfig };
    } else {
      (window as any).__app_config__ = baseConfig;
    }
  } catch (error) {
    console.error("Failed to load tenant config:", error);
    (window as any).__app_config__ = baseConfig;
  }

  // Set dynamic favicon based on company
  setDynamicFavicon();

  createRoot(document.getElementById("root")!).render(<App />);
};

initApp();
